import { render, staticRenderFns } from "./FormDatosMenor.vue?vue&type=template&id=7e46f09c"
import script from "./FormDatosMenor.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDatosMenor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports